import React from 'react';
import { useSelector } from 'react-redux';

import { propsArrowLine } from '../const';
import { getPointXByGeometryParamDragItem, getPointYByGeometryParamDragItem } from '../functions';
import useGetGeometryParamForItem from '../hooks/useGetGeometryParamForItem';
import { RootState } from '../store';
import { DraggableGantType, ItemType } from '../types';
import GantGridArrow from './gantGridArrow';

const GantGridFantomArrow = () => {
    const currentPositionX = useSelector<RootState, number>((state) => state.gantDraggable.currentPositionX);
    const dragging = useSelector<RootState, DraggableGantType>((state) => state.gantDraggable.dragging);
    const currentPositionY = useSelector<RootState, number>((state) => state.gantDraggable.currentPositionY);
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);
    const draggingDrop = useSelector<RootState, DraggableGantType>((state) => state.gantDraggable.draggingDrop);
    const currentPreDropBond = useSelector<RootState, ItemType | null>(
        (state) => state.gantDraggable.currentPreDropBond,
    );
    const currentScrollX = useSelector<RootState, number>((state) => state.gantScroll.currentScrollX);
    const currentScrollY = useSelector<RootState, number>((state) => state.gantScroll.currentScrollY);

    const geometryParamDragItem = useGetGeometryParamForItem(currentDragBond);

    const currentX = currentPositionX - currentScrollX;
    const currentY = currentPositionY - currentScrollY;

    const pointStartX = getPointXByGeometryParamDragItem(dragging, geometryParamDragItem);

    const length = dragging === 'bondLeft' ? -currentX + pointStartX : currentX - pointStartX;

    const x2 = length > 10 ? currentX : pointStartX + (dragging === 'bondLeft' ? -10 : 10);

    const pointStartY = getPointYByGeometryParamDragItem(geometryParamDragItem);

    return (
        <>
            {currentDragBond && (
                <g style={{ pointerEvents: 'none', mixBlendMode: 'normal' }}>
                    <GantGridArrow
                        startItem={currentDragBond}
                        endItem={currentPreDropBond}
                        draggingStart={dragging}
                        draggingEnd={draggingDrop}
                    />
                    {!currentPreDropBond && (
                        <>
                            <line x1={pointStartX} y1={pointStartY} x2={x2} y2={pointStartY} {...propsArrowLine} />
                            <line x1={x2} y1={pointStartY} x2={x2} y2={currentY} {...propsArrowLine} />
                        </>
                    )}
                </g>
            )}
        </>
    );
};

export default React.memo(GantGridFantomArrow);
